











































import slugify from '@/lib/slugify'

export default {
  props: {
    clientId: String
  },
  data: function() {
    return {
      team: {
        slug: '',
        name: ''
      }
    }
  },
  watch: {
    'team.name': function() {
      this.team.slug = slugify(this.team.name)
    }
  },
  methods: {
    saveTeam() {
      this.$api.clientAdmin
        .CreateTeam(this.team)
        .then(() => this.$router.push({ name: 'settings-teams-list' }))
    }
  }
}
